import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { RootContext } from "@-/dev.improve.haniverse.routes._context";
import {
  LearnFlashcardSurfaceReadyMarker,
  useLearnCardSurface,
} from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";
import {
  GraphemeDrillPageLandscapeView,
  WordDrillPageLandscapeView,
} from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._views.landscape";
import {
  GraphemeDrillPagePortraitView,
  WordDrillPagePortraitView,
} from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._views.portrait";
import type { ReactNode } from "react";
import { GraphemeVoiceStudyDrill, WordVoiceStudyDrill } from "#voice-study-drill";

/**
 * The drill front shared by both branches: prompt, glyph and hints, with free-text answers hosted
 * below the card. `activeEffects` belong to the learner's LIVE front only, never to a background
 * copy.
 */
function DrillFlashcardFrontLayout({
  activeEffects,
  landscape,
  portrait,
}: {
  activeEffects: ReactNode;
  landscape: ReactNode;
  portrait: ReactNode;
}) {
  const { isActive } = useLearnCardSurface();
  const [orientation] = useContextSelectors(RootContext, (c) => c.orientation);
  return (
    <>
      {isActive ? activeEffects : null}
      {orientation === "landscape" ? landscape : portrait}
      <LearnFlashcardSurfaceReadyMarker />
    </>
  );
}

/** A grapheme drill's front: the glyph with its meaning or pronunciation prompt. */
export function GraphemeDrillFlashcardFront() {
  return (
    <DrillFlashcardFrontLayout
      activeEffects={<GraphemeVoiceStudyDrill />}
      landscape={<GraphemeDrillPageLandscapeView />}
      portrait={<GraphemeDrillPagePortraitView />}
    />
  );
}

/** A word drill's front: the sentence prompt (or the sentence being produced). */
export function WordDrillFlashcardFront() {
  return (
    <DrillFlashcardFrontLayout
      activeEffects={<WordVoiceStudyDrill />}
      landscape={<WordDrillPageLandscapeView />}
      portrait={<WordDrillPagePortraitView />}
    />
  );
}
